/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountPagedData } from '../../models/account-paged-data';
import { SortType } from '../../models/sort-type';

export interface GetAccounts$Params {
  PageNumber?: number;
  PageSize?: number;
  SearchTerm?: string;
  Role?: string;
  SortField?: string;
  SortType?: SortType;
}

export function getAccounts(http: HttpClient, rootUrl: string, params?: GetAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountPagedData>> {
  const rb = new RequestBuilder(rootUrl, getAccounts.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('SearchTerm', params.SearchTerm, {});
    rb.query('Role', params.Role, {});
    rb.query('SortField', params.SortField, {});
    rb.query('SortType', params.SortType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountPagedData>;
    })
  );
}

getAccounts.PATH = '/account';
